<template>

 <div class="row pr-2">
  <div :class="colclass(0)" v-if="ipages">
    <ul class="nav nav-tabs" :class="ulclass()">
      <li class="nav-item" :class="getclass(p)"  v-for="p in ipages" :key="p.id" @click="setpage(p.id)">
        <a class="nav-link" :class="getclass(p)" data-toggle="tab" style="cursor: pointer;">{{p.des}}</a>
      </li>
      <button class="btn btn-outline btn-success smaller " @click="addelement()" v-if="isaddelement">?</button>
      <button  class="btn btn-outline btn-danger smaller " @click="deleteelement(key,x)" v-if="isdeleteelement">?</button>
    </ul>
  </div>

  <div :class="colclass(1)" v-if="ipage">
      <div class="row">
        <div class="col-12">
          <slot :name="ipage">
            <h3>Attenzione manca componente::{{ipage}}::</h3>
          </slot>
        </div>
      </div>

  </div>
  <d-msg v-if="message" title="delete folder?" :text="getmessage" yesno @close="doclose($event)"/>
</div>

</template>

<script>
export default {
  props: {
     pages:Array,
     page:String,
     vertical:Boolean,
     pills:Boolean,
     askdelete:Boolean
  },
  data () {
    return {
        ipage:undefined,
        message:false
    }
  },
  created() {
      this.ipage=this.page;
      this.ipages.forEach(p => {if (!this.ipage) this.ipage=p.id;  });
  },
  computed: {
    ipages() {
        var r=[];
        if (this.pages) {
            this.pages.forEach((e,i) =>{
              if (e.toLowerCase()!='json' ) {
                if (e.id) {
                  r.push(e);
                } else {
                  r.push({ id:'id'+i,des:e});
                }
              }
            });
        }
        return r;
    },
    isaddelement() {
      return this.$listeners.addelement;
    },
    isdeleteelement() {
      return this.$listeners.deleteelement;
    },
    getmessage() {
      //var myindex=this.ipages.indexOf(this.ipage)
      var temp=this.ipages.filter(e=>e.id==this.ipage)[0].des;
      return "delete page: " + temp + "?";
    }
  },
  methods: {
    setpage(id) {
      var sc=this;
      sc.ipage=id;
      sc.$emit("click",id);
    },
    getclass(p) {
      var a=(p.id==this.ipage?" active":"");
      if (p.disabled) a=a+" disabled";
      return a;
    },
    colclass(modo) {
      if (this.vertical) {
        return modo==0?"col-1":"col-11"; /* 2 : 10 */
      } else {
         return "col-12";
      }
    },
    ulclass() {
      var a="";
      if (this.pills) a="nav-pills";
      if (this.vertical) a+=" flex-column";
      return a;
    },
    deleteelement() {

         /* var h = this.ipage.replace("id","");
          var t = new Number(h);
          t = t - 1;*/
       if (this.askdelete) {
          this.message=true;
          //this.setpage('id' + t);
        } else {

          this.$emit("deleteelement",this.ipage);

        }
      this.$forceUpdate()
    },
    doclose(e) {
        if (e=='yes') this.$emit("deleteelement",this.ipage);
        this.message=false;
    },
    addelement(key) {
      var x1={};
      // risolve automaticamente i coddes
      this.$emit("addelement",x1);
      this.$forceUpdate()

    },

  },


}
</script>




// WEBPACK FOOTER //
// src/_eng/globals/dnav.vue